import { render, staticRenderFns } from "./ImageAnswer.vue?vue&type=template&id=6e67061f&scoped=true&"
import script from "./ImageAnswer.vue?vue&type=script&lang=js&"
export * from "./ImageAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ImageAnswer.vue?vue&type=style&index=0&id=6e67061f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67061f",
  null
  
)

export default component.exports